import { render } from "./iconPack.vue?vue&type=template&id=0fac3cf6"
import script from "./iconPack.vue?vue&type=script&lang=js"
export * from "./iconPack.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__